module.exports = __webpack_public_path__ + "img/two_circle_gray.180d1929.svg";